import { CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import type { AlertProps } from 'antd';
import { Button } from 'antd';

import { AlertModal } from 'app/components/commons/AlertModal/AlertModal';
import { amplitudeTrack } from 'app/utils/track/amplitude';

import styles from './DeactivateModal.module.scss';

type DeactivateModalProps = {
  isOpen: boolean;
  isDisconnectLoading?: boolean;
  isSuccessMode?: boolean;
  onDeactivate: () => void;
  onKeepActivated: () => void;
  onClose: () => void;
};

export const DeactivateModal = ({
  isOpen,
  isDisconnectLoading = false,
  isSuccessMode = false,
  onDeactivate,
  onKeepActivated,
  onClose,
}: DeactivateModalProps) => {
  const alertModalInfo: AlertProps & { isOpen: boolean } = {
    isOpen,
    type: isSuccessMode ? 'success' : 'warning',
    icon: isSuccessMode ? <CheckCircleOutlined /> : <InfoCircleOutlined />,
    message: isSuccessMode
      ? 'Demand successfully sent!'
      : 'Deactivate Auto inventory?',
    className: !isSuccessMode ? styles.alertDisconnect : '',
    description: isSuccessMode ? (
      'Your Account Manager has been contacted.'
    ) : (
      <>
        <div className={styles.alertBody}>
          By deactivating Auto inventory, only your manual data and pricing
          rules will remain.
        </div>

        <div className={styles.alertFooter}>
          <Button
            loading={isDisconnectLoading}
            type="default"
            className={styles.disconnectButton}
            onClick={() => {
              amplitudeTrack('Click disconnect');
              onDeactivate();
            }}
            disabled={isDisconnectLoading}
          >
            Deactivate
          </Button>
          <Button
            disabled={isDisconnectLoading}
            type="primary"
            onClick={() => {
              amplitudeTrack('Click Stay connected');
              onKeepActivated();
            }}
          >
            Keep activated
          </Button>
        </div>
      </>
    ),
    closable: !isSuccessMode,
    onClose,
    style: !isSuccessMode ? { backgroundColor: '#FFF', border: 0 } : {},
  };

  return <AlertModal {...alertModalInfo} />;
};
